import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b97696be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "progress__main_container",
  class: "main_container"
}
const _hoisted_2 = { class: "main-top" }
const _hoisted_3 = { class: "main_title" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "ion-padding custom-skeleton" }
const _hoisted_9 = {
  key: 1,
  class: "top_container"
}
const _hoisted_10 = { class: "space-between" }
const _hoisted_11 = { class: "info_right" }
const _hoisted_12 = { class: "space-between" }
const _hoisted_13 = { class: "company_title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_right_b.png",
  srcset: "/assets/icon/btn_right_b@2x.png 2x,/assets/icon/btn_right_b@3x.png 3x"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company_info_right" }, null, -1))
const _hoisted_16 = { class: "company_detail" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/small_leaf_g.png",
  class: "leaf"
}, null, -1))
const _hoisted_18 = { class: "green" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('|'))
const _hoisted_20 = { class: "info_left" }
const _hoisted_21 = { class: "company_logo" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_24 = { class: "deal_content" }
const _hoisted_25 = { class: "space-between" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 판매자 ", -1))
const _hoisted_27 = { class: "deal_right" }
const _hoisted_28 = { class: "bold" }
const _hoisted_29 = { class: "space-between" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 클럽딜 총 금액 ", -1))
const _hoisted_31 = { class: "deal_right" }
const _hoisted_32 = { class: "bold" }
const _hoisted_33 = { class: "space-between" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 주당 가격 ", -1))
const _hoisted_35 = { class: "bold" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 로그인 후 확인 ")
const _hoisted_38 = { class: "space-between" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 모집 기한 ", -1))
const _hoisted_40 = { class: "deal_right" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row deal_left" }, " 모집 현황 ", -1))
const _hoisted_42 = { class: "gauge_box" }
const _hoisted_43 = { class: "space-between" }
const _hoisted_44 = { class: "lead_info" }
const _hoisted_45 = { class: "c_logo" }
const _hoisted_46 = ["src"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_48 = { class: "deal_right" }
const _hoisted_49 = { class: "bold" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 원 참여 ")
const _hoisted_51 = { class: "white_container" }
const _hoisted_52 = { class: "notice_container" }
const _hoisted_53 = { class: "space-between" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "1인 참여 가능 범위", -1))
const _hoisted_55 = { class: "bold" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 원 ~ ")
const _hoisted_57 = { class: "bold" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_59 = { class: "space-between" }
const _hoisted_60 = { class: "help_circle" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" 서비스 이용료 ")
const _hoisted_62 = { class: "line_through" }
const _hoisted_63 = { class: "bold" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_65 = { class: "notice_box" }
const _hoisted_66 = { class: "padding_white_container" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "related_title" }, " 함께 본 클럽딜 ", -1))
const _hoisted_68 = { class: "clubdeal-badge" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "logo" }
const _hoisted_71 = ["src"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "kakao_klip",
  src: "/assets/icon/kakao_klip@3x.png"
}, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "regular" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "카카오톡"),
  /*#__PURE__*/_createTextVNode("에서 "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "조합가입 증명카드"),
  /*#__PURE__*/_createTextVNode(" 확인하기 > ")
], -1))
const _hoisted_75 = { class: "value_container" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_18B" }, " 가격 정보 ", -1))
const _hoisted_77 = { class: "value_image" }
const _hoisted_78 = ["src"]
const _hoisted_79 = ["src", "srcset"]
const _hoisted_80 = {
  key: 0,
  class: "white_container"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_18B" }, " 성장성분석 그래프 ", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "gray main_13R",
  style: {"margin-top":"3px"}
}, " 총 인원수, 모바일앱 월 사용자수를 한눈에! ", -1))
const _hoisted_83 = { style: {"margin-top":"10px","margin-bottom":"10px"} }
const _hoisted_84 = ["src"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray center main_13R" }, " 이 회사의 고용, 사용자, 재무정보 등 성장지표가 궁금하다면? ", -1))
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" 혁신의숲에서 자세히보기 ")
const _hoisted_87 = { id: "info_box" }
const _hoisted_88 = { class: "info_container" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "뉴스")
], -1))
const _hoisted_90 = ["onClick"]
const _hoisted_91 = { class: "info_container" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "회사소개")
], -1))
const _hoisted_93 = { class: "company_info" }
const _hoisted_94 = { class: "news_list" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "회사명", -1))
const _hoisted_96 = { class: "news_list" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "대표이사", -1))
const _hoisted_98 = { class: "news_list" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "사업자번호", -1))
const _hoisted_100 = { class: "news_list" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "설립일", -1))
const _hoisted_102 = { class: "news_list" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "총 발행 주식수", -1))
const _hoisted_104 = { class: "info_container" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "투자정보")
], -1))
const _hoisted_106 = { class: "doc_left" }
const _hoisted_107 = { class: "item_left" }
const _hoisted_108 = { class: "series" }
const _hoisted_109 = { class: "info_date gray" }
const _hoisted_110 = { class: "item_center" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_112 = { class: "doc_right" }
const _hoisted_113 = { class: "strong" }
const _hoisted_114 = { class: "info_container" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "공시자료")
], -1))
const _hoisted_116 = { class: "doc_left" }
const _hoisted_117 = { class: "info_date gray" }
const _hoisted_118 = ["onClick"]
const _hoisted_119 = { class: "doc_right" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_content" }, " 모든 정보는 참고 및 정보 제공을 위한 것으로, 투자 권유를 목적으로 하지 않습니다. 제공되는 정보는 공개된 자료를 바탕으로 한 것이나 오류가 있을 수 있습니다. 리드엔젤과 엔젤리그는 제공되는 정보의 정확성을 보장하지 않으며, 제공되는 정보를 바탕으로 한 조합 참여의 결과에 대하여 책임지지 않습니다. ", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "출자 위험 안내")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, [
    /*#__PURE__*/_createTextVNode(" 본 위험고지서는 귀하가 (주)엔젤리그가 운영하는 서비스 위에서, 업무집행조합원과 함께 조합에 참여하여 조합을 공동경영하기 전에 출자의 위험을 사전에 충분히 인지할 수 있도록 (주)엔젤리그가 귀하에게 고지하는 내용입니다."),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 1. 귀하의 출자대상은 조합의 지분으로서 투자대상회사의 주식 그 자체가 아닙니다. 설립되는 조합이 비상장주식을 매수하게 되며 귀하는 그 조합의 지분을 보유하게 됩니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 2. 조합의 업무집행조합원 및 다른 조합원은 귀하와 조합의 동업자로서, 조합 출자재산의 운영 및 배분은 조합원 전원의 합의로 이루어지고, 업무집행조합원은 조합의 출자재산을 운용하지 않습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 3. 조합의 매수대상인 투자대상회사의 증권은 원본손실의 위험성이 있으며, 출자한 자금의 원본을 회수할 없음에 따른 손실의 위험이 있음을 이해합니다. 또한 귀하가 예상하거나 기대하는 수익의 일부 또는 전부를 얻지 못할 수 있습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 4. 귀하는 (주)엔젤리그의 홈페이지에 게재된 매수대상회사에 대한 설명, 매수대상회사의 매수조건, 매수대상회사의 매수 시점 및 가격, 업무집행조합원의 성과보수, 업무집행조합원의 역할, 출자위험요소 등을 충분히 확인하였습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 5. 귀하는 (주)엔젤리그는 업무집행조합원이 안전하고 쉽게 조합을 만드는 것을 도와주는 역할만 수행하므로 출자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 조합의 업무집행조합원 역시 귀하와 같이 조합을 설립하고 운영하는 동업자로서 출자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 즉, 출자에 대한 모든 위험은 본인에게 있음을 확인합니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 6. 귀하는 조합을 통해 매수하는 매수대상회사의 비상장증권은 한국거래소의 상장을 목적으로 하는 것이 아니며, 따라서 증권의 환금성에 큰 제약이 있다는 점과 예상 회수금액에 대한 일부 혹은 전부를 회수할 수 없는 위험이 있음을 이해하며, 귀하가 이를 감당할 수 있음을 확인합니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 7. 조합이 매수하게 되는 매수대상회사가 비상장 기업인 경우 성장초기단계에 있는 경우가 많기 때문에, 정기 배당을 실시하는 경우가 매우 드뭅니다. 따라서 배당수익을 기대하고 출자를 할 경우 기대한 만큼의 수익을 얻지 못할 수 있습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 8. 조합이 매수하게 되는 매수대상회사는 지속적으로 성장하기위하여 해당 기업의 정관에 근거하여 유상증자를 실시할 가능성이 높습니다. 유상증자로 인하여 조합이 보유한 지분율은 감소될 수 있습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 9. 귀하는 시장의 상황, 제도의 변경이 있을 수 있으며, 자본시장법 등 관련법규에 근거하여 출자의 한도에 제한이 있는 경우 이를 준수하여야 함을 이해합니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text_line" }, " 10. 귀하는 귀하가 보유한 조합의 지분에 대하여 원칙적으로 1년간 전매가 제한된다는 점을 이해합니다. 단, 조합이 보유한 매수대상회사의 주식은 아무런 제한 없이 매매가 가능합니다. "),
  /*#__PURE__*/_createElementVNode("b", null, "위 사항들은 조합의 출자에 수반되는 위험과 관련하여 귀하가 알아야 할 사항을 간략하게 서술한 것으로 귀하의 위 거래와 관련하여 발생될 수 있는 모든 위험과 중요 사항을 전부 기술한 것은 아닙니다. 따라서 상세한 내용은 (주)엔젤리그 및 관계법규를 통하여 확인하여야 합니다.")
], -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "medium" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "환불 정보")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "refund_list" }, [
      /*#__PURE__*/_createElementVNode("li", null, "단순 변심으로 인한 환불 : 환불 수수료 10만원"),
      /*#__PURE__*/_createElementVNode("li", null, "조합규약 발송 이후 : 환불 수수료 20만원 "),
      /*#__PURE__*/_createElementVNode("li", null, "조합규약 서명 이후 : 환불 불가")
    ]),
    /*#__PURE__*/_createTextVNode(" 비상장주식회사의 비통일주권의 거래를 위해,"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 주식양수도계약, 명의개서*를 완료 해야 합니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 본 과정은 리드엔젤과 (주)엔젤리그가 안전하게 진행합니다. 단, 계약이 완료되지 못한 경우, 바로 공지드리며 영업일 기준 D+8내에 입력하신 환불계좌로 전액 환불됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 입금 선착순에 의한 환불인 경우 사용된 포인트는 3영업일 이내에 복원됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "blue sub_text" }, "*명의개서 : 회사에서 주주명부에 새로운 주주로 등재하는 것")
  ])
], -1))
const _hoisted_123 = { class: "padding_white_container" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "related_title" }, " 함께 본 클럽딜 ", -1))
const _hoisted_125 = { class: "clubdeal-badge" }
const _hoisted_126 = ["onClick"]
const _hoisted_127 = { class: "logo" }
const _hoisted_128 = ["src"]
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_130 = { class: "white_container" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "엔젤리그 사용법")
], -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rec_img",
    src: "/assets/image/img@3x.png",
    alt: ""
  })
], -1))
const _hoisted_133 = /*#__PURE__*/_createTextVNode(" 참여금 입금 확인중. 입금정보 보기 > ")
const _hoisted_134 = {
  key: 1,
  class: "footer_container space-between"
}
const _hoisted_135 = /*#__PURE__*/_createTextVNode(" 클럽딜 참여하려면 로그인 > ")
const _hoisted_136 = {
  src: "/assets/icon/btn_open.png",
  alt: "",
  class: "btn_open",
  srcset: "/assets/icon/btn_open@2x.png 2x,/assets/icon/btn_open@3x.png 3x"
}
const _hoisted_137 = {
  key: 2,
  class: "ion-activatable ripple-parent heart_btn"
}
const _hoisted_138 = ["src"]
const _hoisted_139 = {
  key: 2,
  class: "footer_container space-between"
}
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray_btn clubdeal_footer_btn" }, " 준비 중인 클럽딜 ", -1))
const _hoisted_141 = {
  key: 0,
  class: "heart_img",
  src: "/assets/icon/heart_w.png",
  srcset: "/assets/icon/heart_w@2x.png 2x,/assets/icon/heart_w@3x.png 3x"
}
const _hoisted_142 = {
  key: 1,
  class: "heart_img",
  src: "/assets/icon/heart_n.png",
  srcset: "/assets/icon/heart_n@2x.png 2x,/assets/icon/heart_n@3x.png 3x"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_icon = _resolveComponent("ag-icon")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        id: "ionContentClubDealProgress",
        fullscreen: true,
        "scroll-events": true,
        onIonScroll: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleScroll($event.target)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent btn-back",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':'뒤로가기'});_ctx.closeModal();})
                  }, [
                    _hoisted_5,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.partnershipName), 1)
                ]),
                _createVNode(_component_ag_box_s, {
                  css: {marginRight: '20px'},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':'공유버튼'});_ctx.onShare()})
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_icon, {
                      name: "arrowRedo",
                      css: {width: 26, height: 26, color: 'gray6'}
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_6,
            (!_ctx.partnershipInfo.partnershipName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_avatar, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, { animated: "" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"width":"50%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"width":"80%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"width":"60%"}
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", null, [
                          _createVNode(_component_ion_skeleton_text, {
                            animated: "",
                            style: {"width":"60%"}
                          })
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_ion_skeleton_text, { animated: "" })
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_ion_skeleton_text, {
                            animated: "",
                            style: {"width":"88%"}
                          })
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_ion_skeleton_text, {
                            animated: "",
                            style: {"width":"70%"}
                          })
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_ion_skeleton_text, {
                            animated: "",
                            style: {"width":"60%"}
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.fromCompany && _ctx.partnershipInfo.partnershipName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent company_info_left",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'상단회사정보', 'clickContent':`회사상세링크`});_ctx.useCompanyModal(_ctx.partnershipInfo.stockItemId)})
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createTextVNode(_toDisplayString(_ctx.partnershipInfo.stockItemName) + " ", 1),
                            _hoisted_14
                          ]),
                          _hoisted_15
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ag_box_s, { css: {mb: 8, dp: 'flex', direction: 'row', alignItems: 'center'} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ag_icon, {
                                name: "businessOutline",
                                css: {width: 12, height: 12, mr: 4}
                              }),
                              _createElementVNode("span", null, "추정 시총 " + _toDisplayString(Number(_ctx.partnershipInfo.currentValuation)?_ctx.numberToKorean(_ctx.partnershipInfo.currentValuation)+'원':'정보 없음'), 1),
                              _createVNode(_component_ag_icon, {
                                name: "helpCircleOutline",
                                css: {width: 20, height: 20, color: 'gray3'},
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'상단카드', 'clickContent':'추정시가총액툴팁'}); _ctx.openPopover2(_ctx.numberToKorean(_ctx.partnershipInfo.currentValuation))}, ["stop"]))
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            (_ctx.boardSummary)
                              ? (_openBlock(), _createBlock(_component_ag_box_s, {
                                  key: 0,
                                  css: {dp: 'flex', direction: 'row', alignItems: 'center'}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_17,
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(Number(_ctx.boardSummary.avg_point).toFixed(1)), 1),
                                    _createVNode(_component_ag_box_s, { css: {color: 'bg2', typography: 'main12r', mx: 4} }, {
                                      default: _withCtx(() => [
                                        _hoisted_19
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ag_icon, {
                                      name: "chatbubble",
                                      css: {color: 'green1'}
                                    }),
                                    _createVNode(_component_ag_box_s, { css: {color: 'green1', ml:4} }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.boardSummary.count), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ag_icon, {
                                      name: "chevronForward",
                                      css: {color: 'green1', width: 16, height: 16}
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          class: "img-responsive img-circle",
                          src: _ctx.partnershipInfo.companyLogo
                        }, null, 8, _hoisted_22),
                        _hoisted_23
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.partnershipInfo.partnershipName)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "content_wrap",
                  style: _normalizeStyle({'background' : `${_ctx.partnershipInfo.bgColor}`, 'color' : `${_ctx.partnershipInfo.fontColor}`})
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_ag_icon, {
                          name: "personCircleOutline",
                          css: {width: 20, height: 20, mr: 4}
                        }),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.only3(_ctx.partnershipInfo.sellerNickName)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.expectTotalAmountTo)), 1),
                        _createTextVNode(" 원 (" + _toDisplayString(_ctx.hasSession() ? _ctx.$filters.currency(_ctx.partnershipInfo.totalQty) : '?') + "주) ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_ag_box_s, { css: {dp: 'flex', direction: 'column', justifyContent: 'flex-end', alignItems: 'flex-end'} }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            (_ctx.hasSession())
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.price)), 1),
                                  _hoisted_36
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_37
                                ], 64))
                          ]),
                          _createVNode(_component_ag_box_s, { css: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  } }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ag_box_s, {
                                css: {dp: 'flex', alignItems: 'center', color: _ctx.partnershipInfo.fontColor, typography: 'main12r', bg: 'rgba(0, 0, 0, 0.2)', borderRadius: '4px', padding:'4px 8px'}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ag_icon, {
                                    name: "businessOutline",
                                    css: {mr: 4}
                                  }),
                                  _createVNode(_component_ag_box_s, { css: {ml:'5px', whiteSpace: 'nowrap'} }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 시총 " + _toDisplayString(_ctx.hasSession() ? _ctx.numberToKorean(_ctx.partnershipInfo.price*_ctx.partnershipInfo.totalStockAmount) : '?') + "원 상당 ", 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["css"]),
                              _createVNode(_component_ag_icon, {
                                css: {fontSize: '20px', ml:'5px'},
                                name: "helpCircleOutline",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'클럽딜정보', 'clickContent':`시총 툴팁`});_ctx.openPopover(_ctx.hasSession() ? _ctx.numberToKorean(_ctx.partnershipInfo.price*_ctx.partnershipInfo.totalStockAmount) : '?')})
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.getDate(_ctx.partnershipInfo.dueDateFrom)) + " ~ " + _toDisplayString(_ctx.getDate(_ctx.partnershipInfo.dueDate)) + " " + _toDisplayString(_ctx.printStatus(_ctx.partnershipInfo.partnershipStatus)), 1)
                    ]),
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_ion_progress_bar, {
                        value: _ctx.partnershipInfo.collectedRate * 0.01
                      }, null, 8, ["value"]),
                      _createElementVNode("span", {
                        class: "gauge_text",
                        style: _normalizeStyle({'left' : `calc(${_ctx.partnershipInfo.collectedRate * 0.93}%)`, 'color' : `${_ctx.partnershipInfo.bgColor}`})
                      }, _toDisplayString(_ctx.partnershipInfo.collectedRate) + "% ", 5)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("img", {
                            src: _ctx.partnershipInfo.leadProfile ? _ctx.partnershipInfo.leadProfile : '/assets/icon/lead_default_profile.png',
                            onerror: "this.src='/assets/icon/lead_default_profile.png'",
                            class: "img-responsive img-circle"
                          }, null, 8, _hoisted_46),
                          _hoisted_47
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.nickname) + " 리드엔젤", 1)
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.leadAsset)), 1),
                        _hoisted_50
                      ])
                    ])
                  ])
                ], 4))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.availableAssetFrom)), 1),
                    _hoisted_56,
                    _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.availableAssetTo)), 1),
                    _hoisted_58
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("img", {
                      class: "help_circle_img",
                      src: "/assets/icon/help_circle@3x.png",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'클럽딜정보', 'clickContent':`서비스이용료 툴팁`});_ctx.openPopoverFee()})
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.defaultFee)) + " 원", 1),
                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.serviceFeeAmount)), 1),
                    _hoisted_64
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, " MY 포인트 = " + _toDisplayString(_ctx.$filters.currency(_ctx.userAvailablePoint)) + "p | 포인트 쓰면 이용료 무료! ", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("div", _hoisted_68, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendPartnership, (v, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: (v, idx),
                  class: "badge-container",
                  style: _normalizeStyle(_ctx.recommendPartnership.length-1 === idx ? {'margin-right' : '20px'} : '')
                }, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent deal-badge",
                    style: _normalizeStyle({'background' : `${_ctx.recommendPartnership[idx].bgColor}`}),
                    onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'함께 본 클럽딜 상단', 'clickContent':`${v.partnershipName}`});_ctx.setPartnershipId(v.partnershipId)}
                  }, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("img", {
                        src: _ctx.recommendPartnership[idx].companyLogo ? _ctx.recommendPartnership[idx].companyLogo : '/assets/icon/company_default_img.png',
                        onerror: "this.src='/assets/icon/company_default_img.png'",
                        class: "img-responsive img-circle"
                      }, null, 8, _hoisted_71),
                      _hoisted_72
                    ]),
                    _createElementVNode("div", {
                      class: "collecting",
                      style: _normalizeStyle({'color' : `${_ctx.recommendPartnership[idx].fontColor}`})
                    }, _toDisplayString(_ctx.recommendPartnership[idx].partnershipName), 5),
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 12, _hoisted_69)
                ], 4))
              }), 128))
            ])
          ]),
          _createElementVNode("div", {
            class: "ion-activatable ripple-parent white_container",
            onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'카카오 클립', 'clickContent':'조합가입 증명카드 확인'});_ctx.viewKakaoKlipModal()})
          }, [
            _hoisted_73,
            _hoisted_74,
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
          ]),
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              (_ctx.isLogin)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.partnershipInfo.investmentMemoChartImg
                  }, null, 8, _hoisted_78))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.frame783Png,
                    srcset: `${_ctx.frame783x2Png} x2, ${_ctx.frame783x3Png} x3`
                  }, null, 8, _hoisted_79))
            ])
          ]),
          (_ctx.partnershipInfo.ifGraphLink)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _hoisted_81,
                _hoisted_82,
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("img", {
                    class: "if-graph",
                    src: _ctx.partnershipInfo.ifGraphLink
                  }, null, 8, _hoisted_84)
                ]),
                _hoisted_85,
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent g_btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'성장성분석 그래프', 'clickContent':'혁신의숲에서 자세히보기'});_ctx.openLink(_ctx.partnershipInfo.ifLink);})
                }, [
                  _hoisted_86,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _hoisted_89,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipInfo.press, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v,
                  class: "ion-activatable ripple-parent news_list",
                  onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'뉴스', 'clickContent':'기사 제목'});_ctx.openLink(v.link)}
                }, [
                  _createTextVNode(_toDisplayString(v.title) + " ", 1),
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ], 8, _hoisted_90))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.partnershipInfo.introduction), 1),
              _createElementVNode("div", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.stockItemName), 1)
              ]),
              _createElementVNode("div", _hoisted_96, [
                _hoisted_97,
                _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.ceo), 1)
              ]),
              _createElementVNode("div", _hoisted_98, [
                _hoisted_99,
                _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.bizno), 1)
              ]),
              _createElementVNode("div", _hoisted_100, [
                _hoisted_101,
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.transDate(_ctx.partnershipInfo.foundDate)), 1)
              ]),
              _createElementVNode("div", _hoisted_102, [
                _hoisted_103,
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.totalStockAmount)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _hoisted_105,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipInfo.investHistory, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v,
                  class: "news_list space-between"
                }, [
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("div", _hoisted_108, " Series " + _toDisplayString(v.series), 1),
                      _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.$filters.transDate(v.date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.investor.split('|'), (investor) => {
                        return (_openBlock(), _createElementBlock("span", { key: investor }, [
                          _createTextVNode(_toDisplayString(investor), 1),
                          _hoisted_111
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("span", _hoisted_113, _toDisplayString(v.value), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_114, [
              _hoisted_115,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipInfo.publicAnnouncement, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v,
                  class: "news_list space-between"
                }, [
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.$filters.transDate(v.date)), 1),
                    _createElementVNode("span", {
                      class: "ion-activatable ripple-parent info_link",
                      onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'공시자료', 'clickContent':'공시자료 제목'});_ctx.openLink(v.link)}
                    }, [
                      _createTextVNode(_toDisplayString(v.title) + " ", 1),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 8, _hoisted_118)
                  ]),
                  _createElementVNode("div", _hoisted_119, _toDisplayString(v.sender), 1)
                ]))
              }), 128))
            ]),
            _hoisted_120,
            _hoisted_121,
            _hoisted_122,
            _createElementVNode("div", _hoisted_123, [
              _hoisted_124,
              _createElementVNode("div", _hoisted_125, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendPartnership, (v, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: (v, idx),
                    class: "badge-container"
                  }, [
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent deal-badge",
                      style: _normalizeStyle({'background' : `${_ctx.recommendPartnership[idx].bgColor}`}),
                      onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'함께 본 클럽딜 하단', 'clickContent':`${v.partnershipName}`});_ctx.setPartnershipId(v.partnershipId)}
                    }, [
                      _createElementVNode("div", _hoisted_127, [
                        _createElementVNode("img", {
                          src: _ctx.recommendPartnership[idx].companyLogo ? _ctx.recommendPartnership[idx].companyLogo : '/assets/icon/company_default_img.png',
                          onerror: "this.src='/assets/icon/company_default_img.png'",
                          class: "img-responsive img-circle"
                        }, null, 8, _hoisted_128),
                        _hoisted_129
                      ]),
                      _createElementVNode("div", {
                        class: "collecting",
                        style: _normalizeStyle({'color' : `${_ctx.recommendPartnership[idx].fontColor}`})
                      }, _toDisplayString(_ctx.recommendPartnership[idx].partnershipName), 5),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 12, _hoisted_126)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_130, [
              _hoisted_131,
              _hoisted_132,
              _createElementVNode("div", {
                class: "space-between",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openFAQModal($event.target.id)))
              }, [
                _createElementVNode("div", {
                  id: "info",
                  class: "info_btn",
                  style: {"background":"#222"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'서비스 소개', 'clickContent':'엔젤리그소개'});})
                }, " 엔젤리그소개 "),
                _createElementVNode("div", {
                  id: "FAQ",
                  class: "info_btn",
                  style: {"background":"#4360EC"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'서비스 소개', 'clickContent':'자주묻는질문'});})
                }, " 자주묻는질문 "),
                _createElementVNode("div", {
                  id: "process",
                  class: "info_btn",
                  style: {"background":"#00B7B9"},
                  onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'서비스 소개', 'clickContent':'조합생성과정'});})
                }, " 조합생성과정 ")
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, {
        class: "ion-no-border",
        "no-padding": ""
      }, {
        default: _withCtx(() => [
          (_ctx.submitButtons.length>1&&_ctx.submitButtons[1].code=='notYet')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "ion-activatable ripple-parent light_gray_btn footer_btn_narrow",
                onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':'참여금 입금 확인중. 입금정보 보기'});_ctx.showBank(_ctx.partnershipRequest)})
              }, [
                _hoisted_133,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]))
            : _createCommentVNode("", true),
          (_ctx.showToggle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                (_ctx.user === null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "ion-activatable ripple-parent clubdeal_footer_btn red_btn",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':'클럽딜 참여하려면 로그인 >'});_ctx.$global.openLoginModal(_ctx.refresh)})
                    }, [
                      _hoisted_135,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass([{'blue_btn' : _ctx.submitButtons[0].code=='join',
                   'red_btn' : _ctx.submitButtons[0].code=='anotherNotYet',
                   'gray_btn' : _ctx.submitButtons[0].code=='comingSoon' || _ctx.submitButtons[0].code=='paid' || _ctx.submitButtons[0].code=='cancel'|| _ctx.submitButtons[0].code=='complete'}, "ion-activatable ripple-parent clubdeal_footer_btn"]),
                      onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':`${_ctx.submitButtons[0].name}`});_ctx.btnClick(`${_ctx.submitButtons[0].code}`)})
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.submitButtons[0].name) + " ", 1),
                      _withDirectives(_createElementVNode("img", _hoisted_136, null, 512), [
                        [_vShow, _ctx.submitButtons[0].code=='anotherNotYet']
                      ]),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 2)),
                (_ctx.btnToggle && (_ctx.submitButtons[0].code === 'join' || _ctx.submitButtons[0].code === 'comingSoon'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                      _createElementVNode("img", {
                        class: "heart_img",
                        src: _ctx.submitButtons[1].code === 'unlike' ? '/assets/icon/heart_w@3x.png' : '/assets/icon/heart_g@3x.png',
                        onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':`관심버튼`});_ctx.heartToggle(_ctx.partnershipInfo.partnershipStatus, _ctx.partnershipInfo.partnershipId)})
                      }, null, 8, _hoisted_138),
                      _createElementVNode("div", {
                        style: _normalizeStyle(_ctx.submitButtons[1].code === 'unlike' ? {'color' : '#fff'} : { 'color' : '#8F929B'} )
                      }, _toDisplayString(_ctx.partnershipInfo.likeCount), 5),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", {
                  class: "orange_btn clubdeal_footer_btn",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단 버튼', 'clickContent':`출자금 입금 확인중`});})
                }, " 출자금 입금 확인중 ", 512), [
                  [_vShow, _ctx.submitButtons.length>1&&_ctx.submitButtons[1].code=='notYet']
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_139, [
                _hoisted_140,
                _createElementVNode("div", {
                  class: "heart_btn",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.partnershipLike(_ctx.partnershipInfo.partnershipId)))
                }, [
                  (_ctx.partnershipInfo.partnershipLikeId)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_141))
                    : (_openBlock(), _createElementBlock("img", _hoisted_142)),
                  _createElementVNode("div", {
                    class: _normalizeClass({grey:!_ctx.partnershipInfo.partnershipLikeId})
                  }, _toDisplayString(_ctx.partnershipInfo.likeCount), 3)
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}